module.exports = __webpack_public_path__ + "img/museum.1979ee21.jpg";